export default "__VITE_ASSET__CaH5Oyj3__"